import { storeToRefs } from 'pinia';
import { computed, defineAsyncComponent } from 'vue';
import type { Ref } from 'vue';
import type { UseLiveStreamEvent, UseLiveStreamProvider } from '@/composable/liveStream/useLiveStream';
import { LicenseType, LiveStreamProvider, SportType } from '@/interface/enum';
import { useCustomerStore } from '@/store/customerStore';

const VideoJsStream = defineAsyncComponent(() => import('@/components/liveStream/videoJsStream/VideoJsStream.vue'));

export function useMuayThaiStream(event: Ref<UseLiveStreamEvent | null>): UseLiveStreamProvider {
    const { licenseType } = storeToRefs(useCustomerStore());

    const isAvailable = computed(() => !!(event.value?.stream?.videoUrl
        && event.value.sportType === SportType.MuayThai && licenseType.value !== LicenseType.IOM));

    const isPlayable = computed(() => isAvailable.value);

    const streamDisplay = computed(() => {
        if (!isPlayable.value || !event.value?.stream?.videoUrl) return null;

        return {
            provider: LiveStreamProvider.MuayThai,
            component: VideoJsStream,
            key: event.value.stream.videoUrl,
            props: {
                videoUrl: event.value.stream.videoUrl,
            },
        };
    });

    return {
        isAvailable,
        isPlayable,
        streamDisplay,
    };
}
